import { motion } from "framer-motion";
import { CalendarCheck, Link2, TrendingUp, Users } from "lucide-react";

const CARDS = [
  { key: "total", label: "Total registrations", icon: Users, testId: "stat-total" },
  { key: "today", label: "Today", icon: CalendarCheck, testId: "stat-today" },
  { key: "week", label: "Last 7 days", icon: TrendingUp, testId: "stat-week" },
  { key: "active_links", label: "Active referral links", icon: Link2, testId: "stat-links" },
];

export function StatsCards({ stats, loading }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {CARDS.map((card, index) => {
        const Icon = card.icon;
        return (
          <motion.div key={card.key} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.07, duration: 0.5 }} className="admin-card relative overflow-hidden p-6">
            <span className="absolute -right-8 -top-8 h-28 w-28 rounded-full border border-[#f2d28f]/20" aria-hidden="true" />
            <div className="mb-5 flex items-center justify-between">
              <span className="text-xs font-semibold text-white/60">{card.label}</span>
              <span className="grid h-9 w-9 place-items-center rounded-full bg-[#d9ad57]/15 text-[#f2d28f]">
                <Icon className="h-4 w-4" />
              </span>
            </div>
            <div className="stat-number text-[#f2d28f]" data-testid={card.testId}>{loading || !stats ? "–" : stats[card.key]}</div>
          </motion.div>
        );
      })}
    </div>
  );
}
